import produce from 'immer';

import { FETCH_POLICIES_SUCCEEDED, LOGOUT } from '../../constants/actionTypes';

const initState = [];

export default produce((draft, action) => {
  switch (action.type) {
    case FETCH_POLICIES_SUCCEEDED: {
      return action.payload.result;
    }

    case LOGOUT: {
      return initState;
    }
  }
}, initState);
